import CalculatorOutlined from './src/calculator-outlined';
export default CalculatorOutlined;